import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { AuthService } from '@journal/app/core/api/auth/auth.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';
import { JournalService } from '@journal/app/core/api/journal/journal.service';
import { HeaderService } from '@sparro/app/core/api/header/header.service';

@Component({
  selector: 'app-journal-edit-router',
  templateUrl: './journal-edit-router.component.html',
  styleUrls: ['./journal-edit-router.component.scss']
})
export class JournalEditRouterComponent implements OnInit, AfterViewInit {
  sidenavBottomLink: string = `https://uni.xyz/journal/journal-page-discover-ways-to-use-the-jo`;
  currentIndex: number = 0;
  leftSideNav: boolean = false;
  sections = [
    {
      id: 0,
      title: `Content`,
      icon: `icon-rearrange-fill`,
      subSections: [
        {
          title: `Title`,
          added: false,
          icon: `icon-title`,
          required: true
        },
        {
          title: `Description`,
          added: false,
          icon: `icon-description`,
          required: true
        },
        {
          title: `Body`,
          added: false,
          icon: `icon-body`,
          required: true
        }
      ]
    },
    {
      id: 7,
      title: `Meta Data`,
      icon: `icon-person-fill`,
      subSections: [
        {
          title: `Thumbnail`,
          added: false,
          icon: `icon-image`,
          required: true
        },
        {
          title: `Discipline`,
          added: false,
          icon: `icon-discipline`,
          required: true
        }
      ]
    }
  ];

  desktopView: boolean = false;
  tabletView: boolean = false;
  mobileView: boolean = false;
  @ViewChild('leftnav') leftnav: MatDrawer;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private journalService: JournalService,
    public breakpointObserver: BreakpointObserver,
    private headerService: HeaderService
  ) {}

  ngOnInit(): void {
    this.headerService.setHeaderWidth('none');
    this.headerService.getLeftNav().subscribe(res => {
      this.leftSideNav = res;
    });
    this.initializeBreakpoints();
  }

  ngAfterViewInit(): void {
    this.journalService.getBlogValue().subscribe(res => {
      this.sections[0].subSections[0].added = res?.title;
      this.sections[0].subSections[1].added = res?.tagline;
      this.sections[0].subSections[2].added =
        (res?.body ? res.body.length : res?.content?.length) > 30;
      this.sections[1].subSections[0].added = res?.image;
      this.sections[1].subSections[1].added = res?.disciplines?.length;
    });
  }
  initializeBreakpoints(): void {
    this.breakpointObserver
      .observe([BREAKPOINTS.below.md, BREAKPOINTS.between.md_lg, BREAKPOINTS.above.lg])
      .subscribe(result => {
        this.mobileView = Boolean(result.breakpoints[BREAKPOINTS.below.md]);
        this.tabletView = Boolean(result.breakpoints[BREAKPOINTS.between.md_lg]);
        this.desktopView = Boolean(result.breakpoints[BREAKPOINTS.above.lg]);
      });
  }

  goToRoute(id) {
    this.currentIndex = id;
    if (this.route.snapshot.params.uuid) {
      this.router.navigate([`${id == 0 ? './' : './meta'}`], { relativeTo: this.route });
    }
  }

  closeBackdrop(): void {
    this.headerService.setLeftNav(false);
    this.leftnav.toggle();
  }
}
